import {Component, inject} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {RouterLink} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {AuthService} from '../../../services/auth/auth.service';
import {initialSignupRoute} from '../../signup/specific-signup.routes';
import {loginRoute} from '../../../app.routes';

@Component({
  selector: 'homey-native-landing-page',
  standalone: true,
  templateUrl: './native-landing.component.html',
  imports: [
    ButtonModule,
    RouterLink,
  ],
  host: {
    class: 'flex flex-col h-full'
  }
})
export class NativeLandingComponent {
  private readonly userService = inject(UserService);
  private readonly authService = inject(AuthService);

  protected readonly user = this.userService.user;
  protected readonly initialSignupRoute = initialSignupRoute;
  protected readonly loginRoute = loginRoute;

  protected onLogoutClick() {
    this.authService.logout();
  }
}
